import React from "react";
import {
  CardContent,
  Typography,
  Box,
  Stack,
  Divider,
  IconButton,
  Tooltip,
  Chip,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import { StyledCard } from "../common/StyledComponents";

const DocumentHeaderCard = ({ documentHeader, onView, onEdit }) => {
  const { documentType, companySnapshot } = documentHeader;

  const primaryColor =
    documentHeader.templateMetadata?.theme?.primaryColor || "#003366";

  return (
    <StyledCard>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <DescriptionIcon />
            <Box
              sx={{
                width: 16,
                height: 16,
                borderRadius: "50%",
                bgcolor: primaryColor,
              }}
            />
            <Typography variant="h6" fontWeight="bold">
              {documentType.replace(/_/g, " ")}
            </Typography>
          </Box>
          <Stack direction="row">
            {onView && (
              <Tooltip title="View Details">
                <IconButton onClick={onView} size="small" color="primary">
                  <VisibilityOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onEdit && (
              <Tooltip title="Edit Header">
                <IconButton onClick={onEdit} size="small" color="secondary">
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Typography variant="body2" color="text.secondary" gutterBottom>
          Assigned Company Identity
        </Typography>
        <Typography variant="body1" fontWeight="500">
          {companySnapshot?.companyName || "N/A"}
        </Typography>

        <Box mt={2}>
          <Chip
            label={`${Object.keys(documentHeader.templateMetadata || {}).length} Meta Keys`}
            size="small"
            variant="outlined"
          />
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default DocumentHeaderCard;
